import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlBusinessResponse extends IIsiDtoPresentationLogicResponse  {
    getCheckBusinessResult?: IIsiDtoPlCheckBusinessResult;
}
export interface IIsiDtoPlCheckBusinessResult extends IIsiDataTransferObject  {
    businessResult?: IIsiServerToClientBusinessObject;
}
export interface IIsiServerToClientBusinessObject {
}
export class IsiDtoPlCheckBusinessResult extends IsiDataTransferObject implements IIsiDtoPlCheckBusinessResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.CheckBusiness.IsiDtoPlCheckBusinessResult, Isilog.IsiComponent.IsiDataTransferObject";
    businessResult?: IIsiServerToClientBusinessObject;

    constructor(data?: IIsiDtoPlCheckBusinessResult) {
        super(data);
        if (data) {
            this.businessResult = data.businessResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.businessResult = _data["businessResult"];
        }
    }

    static fromJS(data?: IIsiDtoPlCheckBusinessResult): IsiDtoPlCheckBusinessResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlCheckBusinessResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["businessResult"] = this.businessResult != null ? (<any>this.businessResult).toJSON() : <any>null;
        return data;
    }
}
export class IsiDtoPlBusinessResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlBusinessResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.CheckBusiness.IsiDtoPlBusinessResponse, Isilog.IsiComponent.IsiDataTransferObject";
    getCheckBusinessResult?: IsiDtoPlCheckBusinessResult;

    constructor(data?: IIsiDtoPlBusinessResponse) {
        super(data);
        if (data) {
            this.getCheckBusinessResult = data.getCheckBusinessResult && !(<any>data.getCheckBusinessResult).toJSON ? new IsiDtoPlCheckBusinessResult(data.getCheckBusinessResult) : <IsiDtoPlCheckBusinessResult>this.getCheckBusinessResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getCheckBusinessResult = _data["getCheckBusinessResult"] ? IsiDtoPlCheckBusinessResult.fromJS(_data["getCheckBusinessResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlBusinessResponse): IsiDtoPlBusinessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlBusinessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getCheckBusinessResult"] = this.getCheckBusinessResult != null ? (<any>this.getCheckBusinessResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlBusinessRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlBusinessResponse;
    primaryKeyValues?: string;
    checkToDo?: boolean;
    codeAction?: string;
    codeTreatment?: string;
    infosOtherFieldsEntity?: { [key: string]: string; };
    infosEntity?: { [key: string]: string; };
}
export class IsiDtoPlBusinessRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlBusinessRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.CheckBusiness.IsiDtoPlBusinessRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlBusinessResponse;
    primaryKeyValues?: string;
    checkToDo?: boolean;
    codeAction?: string;
    codeTreatment?: string;
    infosOtherFieldsEntity?: { [key: string]: string; };
    infosEntity?: { [key: string]: string; };

    constructor(data?: IIsiDtoPlBusinessRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlBusinessResponse(data.response) : <IsiDtoPlBusinessResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlBusinessResponse.fromJS(_data["response"]) : <any>null;
            this.primaryKeyValues = _data["primaryKeyValues"] !== undefined ? _data["primaryKeyValues"] : <any>null;
            this.checkToDo = _data["checkToDo"] !== undefined ? _data["checkToDo"] : false;
            this.codeAction = _data["codeAction"] !== undefined ? _data["codeAction"] : <any>null;
            this.codeTreatment = _data["codeTreatment"] !== undefined ? _data["codeTreatment"] : <any>null;
            this.infosOtherFieldsEntity = _data["infosOtherFieldsEntity"];
            this.infosEntity = _data["infosEntity"];
        }
    }

    static fromJS(data?: IIsiDtoPlBusinessRequest): IsiDtoPlBusinessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlBusinessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["primaryKeyValues"] = this.primaryKeyValues !== undefined ? this.primaryKeyValues : <any>null;
        data["checkToDo"] = this.checkToDo !== undefined ? this.checkToDo : false;
        data["codeAction"] = this.codeAction !== undefined ? this.codeAction : <any>null;
        data["codeTreatment"] = this.codeTreatment !== undefined ? this.codeTreatment : <any>null;
        data["infosOtherFieldsEntity"] = this.infosOtherFieldsEntity !== undefined ? this.infosOtherFieldsEntity : <any>null;
        data["infosEntity"] = this.infosEntity !== undefined ? this.infosEntity : <any>null;
        return data;
    }
}
